// Performance optimization utilities

// Lazy load images when they come into viewport
export const setupLazyLoading = () => {
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          imageObserver.unobserve(img);
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
};

// Preload critical resources
export const preloadCriticalResources = () => {
  const criticalResources = [
    '/images/logo.webp',
    // Add other critical images here
  ];

  criticalResources.forEach(resource => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = resource;
    document.head.appendChild(link);
  });
};

// Optimize font loading
export const optimizeFontLoading = () => {
  // External font loading removed to avoid render-blocking requests.
};

// Remove unused CSS (this would be done at build time in a real app)
export const removeUnusedCSS = () => {
  // This is a placeholder - in production, use tools like PurgeCSS
  console.log('CSS optimization should be handled at build time');
};

// Compress and optimize images (placeholder for build-time optimization)
export const optimizeImages = () => {
  // This would typically be handled by build tools like webpack or Next.js
  console.log('Image optimization should be handled at build time');
};

// Initialize all performance optimizations
export const initializePerformanceOptimizations = () => {
  // Run after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupLazyLoading();
      preloadCriticalResources();
      optimizeFontLoading();
    });
  } else {
    setupLazyLoading();
    preloadCriticalResources();
    optimizeFontLoading();
  }
};
